// Comms polish hotfix (1.12.233-beta): the small, non-blocking "New version available — Reload" pill.
// It appears when src/lib/appUpdate.js finds a newer deploy than the one this window is running; Reload saves unsent
// drafts (or warns), activates any waiting service worker and reloads. It never covers the page or takes focus.
import React, { useEffect, useState } from 'react';
import { applyAppUpdate, watchForAppUpdate } from '../../lib/appUpdate';

export default function AppUpdatePrompt({ watch = watchForAppUpdate, apply = applyAppUpdate, initialUpdate = null }) {
    const [update, setUpdate] = useState(initialUpdate);
    useEffect(() => watch((found) => setUpdate(found || { waiting: null })), [watch]);
    if (!update) return null;
    return (
        <div className="ia-app-update" role="status" aria-live="polite" data-app-update="true">
            <span className="ia-app-update__text">New version available<span aria-hidden="true"> —</span></span>
            <button
                type="button"
                className="ia-app-update__reload"
                onClick={() => apply({ waiting: update.waiting || null })}
                data-app-update-reload="true"
            >
                Reload
            </button>
        </div>
    );
}
